import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import PlatformGrid from './components/PlatformGrid';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  const seoTitle = 'Po文导航 - 原创内容发布平台推荐 | 精选po文网站大全';
  const seoDescription = '寻找优质po文网站？Po文导航精选多款主流po文网站，涵盖注册流程、发布技巧、流量变现与读者互动策略，帮助创作者快速找到适合自己的po文网站，轻松开启内容创作之旅。';
  const seoKeywords = 'po文网站,po文网站推荐,po文网站注册,po文网站发布教程,免费po文网站,po文网站流量变现,创作者po文平台';

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Po文导航',
    url: 'https://powen.example.com',
    description: seoDescription,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://powen.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Po文导航',
    url: 'https://powen.example.com',
    description: '原创内容发布平台推荐与创作指南',
  };

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        canonicalUrl="https://powen.example.com"
        ogImage="https://readdy.ai/api/search-image?query=Collection%20of%20writing%20platforms%20illustrated%20as%20colorful%20floating%20cards%2C%20warm%20beige%20and%20cream%20background%2C%20modern%20editorial%20design&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{ ...websiteSchema, ...orgSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <PlatformGrid />
        <ArticleList />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}